document.addEventListener('DOMContentLoaded', function () {
    const slidesContainer = document.querySelector('.slides');
    const slides = document.querySelectorAll('.slide');
    const prevButton = document.querySelector('.prev-btn');
    const nextButton = document.querySelector('.next-btn');

    let currentSlide = 0;

    function updateSlidePosition() {
        const offset = currentSlide * -100;
        slidesContainer.style.transform = `translateX(${offset}%)`;
        updateButtonsVisibility();
    }

    function updateButtonsVisibility() {
        prevButton.style.display = currentSlide === 0 ? 'none' : '';
        nextButton.style.display = currentSlide === slides.length - 1 ? 'none' : '';
    }

    function showNextSlide() {
        if (currentSlide < slides.length - 1) {
            currentSlide++;
            updateSlidePosition();
        }
    }

    function showPrevSlide() {
        if (currentSlide > 0) {
            currentSlide--;
            updateSlidePosition();
        }
    }

    nextButton.addEventListener('click', showNextSlide);
    prevButton.addEventListener('click', showPrevSlide);

    // Initial visibility update
    updateButtonsVisibility();
});
